"use client";
import type { LatLng } from "@components/store-locator/humanize-distance";
import type { IPartFilter, IPartSortByOption } from "@contentful-api/types/contentful";
import type { SizeLocales } from "@lib/constants/filtersConstants";
import { createContext } from "react";

export interface StaticFiltersContextValue {
    // Static configuration
    listOfFilters: IPartFilter[];
    sortByOptionsList: IPartSortByOption[];
    // Static methods
    clearRefinements: () => void;
    // Size locale (could be moved to separate context)
    sizeLocale: string;
    setSizeLocale: (locale: SizeLocales) => void;
    clientLocation: LatLng | null;
    storeIdsForSelectedSizes: Set<string> | null;
    sizeValuesForSelectedStores: Set<string> | null;
}

export const FiltersContext = createContext<StaticFiltersContextValue>({
    listOfFilters: [],
    sortByOptionsList: [],
    clearRefinements: () => {},
    sizeLocale: "",
    setSizeLocale: () => {},
    clientLocation: null,
    storeIdsForSelectedSizes: null,
    sizeValuesForSelectedStores: null,
});
